export default __webpack_public_path__ + "static/media/q7_03_sp.85e1c1b4.jpg";